import { useDemoMode } from '../lib/demo';

/**
 * One-click switch for the client-side sample data used while testing.
 * Lives in the nav so it's obvious when the marketplace is showing samples.
 */
export default function DemoToggle() {
  const [on, setOn] = useDemoMode();
  return (
    <button
      type="button"
      className={`demo-toggle${on ? ' on' : ''}`}
      onClick={() => setOn(!on)}
      title={
        on
          ? 'Sample listings are shown for testing. Click to turn off.'
          : 'Show sample listings for testing. Nothing is written to the database.'
      }
    >
      {on ? 'Demo data: ON' : 'Demo data: OFF'}
    </button>
  );
}
